import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  className?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, className = "", children, ...props }, ref) => {
    return (
      <div className={twMerge("flex w-96 flex-col gap-1", className)}>
        {label && (
          <label
            htmlFor={props.id}
            className="flex text-sm font-medium text-secondary-20 dark:text-secondary"
          >
            {label}
          </label>
        )}
        <select
          ref={ref}
          className={twMerge(
            "h-[50px] w-full rounded border border-neutral-variant-60 bg-surface-container-low px-3 py-2 text-secondary-20",
            "dark:border-neutral-variant-60 dark:bg-surface-container-low-dark dark:text-secondary",
            error ? "border-error-60 dark:border-error-40" : "",
            className,
          )}
          {...props}
        >
          {children}
        </select>
        {error && (
          <p className="mt-1 text-sm text-error-60 dark:text-error-40">
            {error}
          </p>
        )}
      </div>
    );
  },
);

Select.displayName = "Select";
